// import axios from "axios";

// const API_URL = process.env.REACT_APP_URL;

// const api = axios.create({
//     baseURL: API_URL,
// });

// //  AUTO TOKEN ATTACH (MAIN FIX)
// api.interceptors.request.use((config) => {
//     const token = localStorage.getItem("_ux98c_v1");

//     if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//     }

//     config.headers["Content-Type"] = "application/json";

//     return config;
// });

// export default api;





import axios from 'axios';
import { handleLogout } from './logoutService';

export const API_BASE_URL =process.env.REACT_APP_URL;
// export const   API_BASE_URL='https://sellercms-qc.dropdash.co';
export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
}); // Create the axios instance

// Add a request interceptor
axiosInstance.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("_ux98c_v1"); // taking auth token from local Storage

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers = {
      ...config.headers,
      ...authHeader()
    };
    return config;
  },
  function (error) {

    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const status = error?.response?.status;
    // Handle the error
    if (401 === status) {
      if (window.location.pathname !== "/login")handleLogout();
    }
    else if (405 === status || 403 === status) {
      handleLogout();
    }
    else {
      return Promise.reject(error);
    }
  }
);
export default function authHeader(isMultipart) {

  const token =localStorage.getItem("_ux98c_v1");

 

  if (isMultipart) {
    if (token) {
      return { "Content-Type": "multipart/form-data", 'Authorization': "Bearer " + token };
    } else {
      return { "Content-Type": "multipart/form-data" };
    }
  }
  else {
    if (token) {
      return { 'Authorization': "Bearer " + token };
    } else {
      return {};
    }
  }
};